import { render, staticRenderFns } from "./OpenBaseNameDialog.vue?vue&type=template&id=8851ce9a&lang=pug"
import script from "./OpenBaseNameDialog.vue?vue&type=script&lang=js"
export * from "./OpenBaseNameDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports